import { BaseTable, DateInput, Loading, PaginationData, Select } from "components"
import { useReligion } from "pages/Card/Transaction/CreateNewEmployee/components/FormSection/utils"
import { useEffect, useState } from "react"
import { useQuotation } from "../utils"
import moment from "moment"

export const TableReturn = () => {
  const [pagination, setPagination] = useState<PaginationState>(default_pagination_value)
  const dataCustomer = useReligion()
  const dataQuotation = useQuotation(pagination)

  useEffect(() => {
    if(pagination) {
      dataQuotation.refetch()
    }
    // eslint-disable-next-line
  }, [pagination])
  

  return (
    <section>
      <div className="flex gap-3">
        <div className="max-w-[200px] w-full">
          <DateInput
            label="START DATE"
            placeholderText="dd/MM/yyyy"
            selected={pagination?.startDate ? moment(pagination?.startDate).toDate() : null}
            onChange={(date) => setPagination({ ...pagination, startDate: moment(date).format("YYYY-MM-DD") })}
          />
        </div>
        <div className="max-w-[200px] w-full">
          <DateInput
            label="END DATE"
            placeholderText="dd/MM/yyyy"
            selected={pagination?.endDate ? moment(pagination?.endDate).toDate() : null}
            onChange={(date) => setPagination({ ...pagination, endDate: moment(date).format("YYYY-MM-DD") })}
          />
        </div>
        <div className="max-w-[200px] w-full">
          <Select
            label="CUSTOMER"
            placeholder="Select customer..."
            isLoading={dataCustomer?.isLoading}
            options={[ { label: "ALL", value: "" }, ...dataCustomer?.data]}
            value={dataCustomer?.data?.find(item => item.value === pagination?.customer?.toString())}
            onChange={e => setPagination({ ...pagination, customer: e?.value })}
          />
        </div>
        <div className="max-w-[200px] w-full">
          <Select
            label="BILL"
            placeholder="Select bill..."
            isLoading={dataCustomer?.isLoading}
            options={[ { label: "ALL", value: "" }, ...dataCustomer?.data]}
            value={dataCustomer?.data?.find(item => item.value === pagination?.status?.toString())}
            onChange={e => setPagination({ ...pagination, status: e?.value })}
          />
        </div>
        <div className="max-w-[200px] w-full">
          <Select
            label="APPROVAL"
            placeholder="Select approval..."
            isLoading={dataCustomer?.isLoading}
            options={[ { label: "ALL", value: "" }, ...dataCustomer?.data]}
            value={dataCustomer?.data?.find(item => item.value === pagination?.status?.toString())}
            onChange={e => setPagination({ ...pagination, status: e?.value })}
          />
        </div>
        <div className="max-w-[200px] w-full">
          <Select
            label="STATUS"
            placeholder="Select status..."
            isLoading={dataCustomer?.isLoading}
            options={[ { label: "ALL", value: "" }, ...dataCustomer?.data]}
            value={dataCustomer?.data?.find(item => item.value === pagination?.status?.toString())}
            onChange={e => setPagination({ ...pagination, status: e?.value })}
          />
        </div>
      </div>

      <div className="overflow-x-auto mt-12">
        <BaseTable className="border-collapse">
          <thead>
            <tr>
              <th>NO</th>
              <th>RETURN ID</th>
              <th>DATE</th>
              <th>REF INVOICE ID</th>
              <th>APPROVAL</th>
              <th>LOCATION</th>
              <th>QTY RETURN</th>
              <th>TOTAL RETURN</th>
            </tr>
          </thead>
          <tbody>
            {dataQuotation?.isLoading || dataQuotation?.data?.items?.length === 0 ? (
              <tr>
                <td colSpan={8} className="text-center">
                  <Loading
                    loading={dataQuotation?.isLoading}
                    errorText="No data available"
                  />
                </td>
              </tr>
            ) : (
              <tr>
                <td className="text-center">1</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
              </tr>
            )}
          </tbody>
        </BaseTable>
      </div>

      <div className="mt-4 text-right">{`Total Return: ${"-"}`}</div>

      <div className="mt-5">
        <PaginationData
          data={dataQuotation?.data}
          pagination={pagination}
          setPagination={setPagination}
        />
      </div>
    </section>
  )
}

const default_pagination_value = {
  total: 0,
  page: 1,
  limit: 10,
  pages: 1,
  keyword: "",
}
type PaginationState = {
  total: number;
  page: number;
  limit: number;
  pages: number;
  keyword: string;
  startDate?: string;
  endDate?: string;
  customer?: string;
  status?: string;
}